export class FiltrosFondo{

    Cod : string = '';
    Estado : string = '';
    Parti : string = '';
    FechaIni : string = '';
    FechaFin : string = '';
}